class BlockFormation extends HTMLElement {
  constructor() {
    super();

    this.tabsButton = document.querySelectorAll('.formation-block__tab-link');
    this.tabsContent = document.querySelectorAll('.formation-block__tab-content');

    if (this.tabsButton && this.tabsContent) {
        this.tabsButton.forEach((tab, index) => {
            tab.addEventListener("click", () => {
                this.removeActiveClass();                
                tab.classList.add("formation-block__tab-link--active");
                this.tabsContent[index].classList.add("formation-block__tab-content--active");
            })
        })
    }
  }

  removeActiveClass() {
    this.tabsButton.forEach(tab => tab.classList.remove("formation-block__tab-link--active"));
    this.tabsContent.forEach(content => content.classList.remove("formation-block__tab-content--active"));
  }
}

customElements.define("block-formation", BlockFormation);
